import trudbooksDescription from './data/trudbooksDescription';

// Constants for service provider types
export const SERVICE_TYPES = {
  ACCOUNTING: "Accounting Services",
  LEGAL: "Legal Services",
  CONSULTING: "Business Consulting",
  TAX: "Tax Services",
  ASSURANCE: "Assurance Services",
  TECH: "Technology Services",
  MARKETING: "Marketing Services",
  EDUCATION: "Educational Services"
};

// Service Provider Data Structure
export const SERVICE_PROVIDERS = [
  {
    id: "trudbooks-accounting-1",
    name: "TruDBooks",
    types: [SERVICE_TYPES.ACCOUNTING, SERVICE_TYPES.TAX, SERVICE_TYPES.ASSURANCE],
    description: trudbooksDescription,
    logo: "/truD.avif", // Updated to use the new image file
    //rating: 4.8, // Optional field for future use
    location: "National", // Optional field for future use
    services: [
      {
        id: "acc-service-2",
        name: "Monthly Bookkeeping",
        description: "Shariah-compliant bookkeeping services",
        details: "Monthly bookkeeping service ensuring all transactions are Shariah-compliant",
        pricing: {
          type: "custom",
          startingAt: 500,
          currency: "USD",
          period: "monthly"
        },
        features: [
          "Accounting",
          "Tax Planning",
          "Cash Flow Management",
          "Company Formation",
          "Human Resources and Management",
          "Assurance",
          "Forensic Accounting",
          "Internal Audit",
          "Trainings",
          "Consulting"
        ]
      }
    ],
    contactInfo: {
      email: "bsanneh@trudbooks.org",
      phone: "+1-907-205-7029",
      website: "https://www.trudbooks.org"
    }
  }
]; 